"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var variables = {
  primaryTheme: "#43c6ac",
  orange: "#fd9026",
  white: "#fff",
  grey: "#58627c",
  grey2: "#797a7a",
  grey3: "#cdcdcd",
  grey4: "#828282",
  iconColor: {
    "default": "#7d7d7d",
    primary: "#18AF8B",
    warning: "#fab446",
    progress: "#f2994a",
    danger: "#d3485d",
    white: "#ffffff",
    dark: "#1c1c1c",
    red: "#eb5757",
    purple: "#5d78ff",
    blue: "#0711FF",
    yellow: "#FAB446",
    pink: "#FD3995"
  }
};
var _default = variables;
exports["default"] = _default;